export default {
  development: {
    read: process.env.VUE_APP_API_URL_READ || 'https://app-api.hi-light.vn/api/',
    write: process.env.VUE_APP_API_URL_WRITE || 'https://app-api.hi-light.vn/api/',
  },
}
